const javaLessons = [
  {
    title: "Hello World in Java",
    code: `// Hello World Program
public class HelloWorld {
    public static void main(String[] args) {
        System.out.println("Hello, World!");
    }
}`
  },
  {
    title: "Variables and Data Types",
    code: `// Variables and Data Types
public class Variables {
    public static void main(String[] args) {
        // Primitive data types
        int age = 25;
        double salary = 50000.50;
        char grade = 'A';
        boolean isJavaFun = true;
        float percentage = 85.5f;
        long bigNumber = 123456789L;
        
        // Reference data type
        String name = "Rajan";
        
        System.out.println("Name: " + name);
        System.out.println("Age: " + age);
        System.out.println("Salary: " + salary);
        System.out.println("Grade: " + grade);
        System.out.println("Is Java Fun? " + isJavaFun);
        System.out.println("Percentage: " + percentage);
        System.out.println("Big Number: " + bigNumber);
    }
}`
  },
  {
    title: "Input and Output",
    code: `// Input and Output using Scanner
import java.util.Scanner;

public class InputOutput {
    public static void main(String[] args) {
        Scanner scanner = new Scanner(System.in);
        
        System.out.print("Enter your name: ");
        String name = scanner.nextLine();
        
        System.out.print("Enter your age: ");
        int age = scanner.nextInt();
        
        System.out.print("Enter your height (in meters): ");
        double height = scanner.nextDouble();
        
        System.out.println("\\n--- User Information ---");
        System.out.println("Name: " + name);
        System.out.println("Age: " + age);
        System.out.println("Height: " + height + " meters");
        
        scanner.close();
    }
}`
  },
  {
    title: "Arithmetic Operations",
    code: `// Arithmetic Operations
public class Arithmetic {
    public static void main(String[] args) {
        int a = 15, b = 4;
        
        System.out.println("a = " + a + ", b = " + b);
        System.out.println("Addition: " + (a + b));
        System.out.println("Subtraction: " + (a - b));
        System.out.println("Multiplication: " + (a * b));
        System.out.println("Division: " + (a / b));
        System.out.println("Modulus: " + (a % b));
        
        // Increment and decrement
        int x = 10;
        System.out.println("\\nOriginal x: " + x);
        x++;
        System.out.println("After increment: " + x);
        x--;
        System.out.println("After decrement: " + x);
        
        // Compound assignment
        int y = 5;
        y += 3; // y = y + 3
        System.out.println("y after += 3: " + y);
    }
}`
  },
  {
    title: "If-Else Statement",
    code: `// If-Else Statement
public class Conditionals {
    public static void main(String[] args) {
        int number = 10;
        
        if (number > 0) {
            System.out.println("Number is positive");
        } else if (number < 0) {
            System.out.println("Number is negative");
        } else {
            System.out.println("Number is zero");
        }
        
        // Multiple conditions
        int age = 20;
        if (age >= 18 && age <= 65) {
            System.out.println("You are an adult");
        } else if (age < 18) {
            System.out.println("You are a minor");
        } else {
            System.out.println("You are a senior");
        }
        
        // Ternary operator
        int marks = 75;
        String result = (marks >= 40) ? "Pass" : "Fail";
        System.out.println("Result: " + result);
    }
}`
  },
  {
    title: "Switch Statement",
    code: `// Switch Statement
public class SwitchExample {
    public static void main(String[] args) {
        int day = 3;
        
        switch(day) {
            case 1:
                System.out.println("Monday");
                break;
            case 2:
                System.out.println("Tuesday");
                break;
            case 3:
                System.out.println("Wednesday");
                break;
            case 4:
                System.out.println("Thursday");
                break;
            case 5:
                System.out.println("Friday");
                break;
            case 6:
                System.out.println("Saturday");
                break;
            case 7:
                System.out.println("Sunday");
                break;
            default:
                System.out.println("Invalid day");
        }
        
        // Enhanced switch (Java 14+)
        String grade = "B";
        String message = switch(grade) {
            case "A" -> "Excellent!";
            case "B" -> "Good!";
            case "C" -> "Average";
            default -> "Need improvement";
        };
        System.out.println("Grade " + grade + ": " + message);
    }
}`
  },
  {
    title: "For Loop",
    code: `// For Loop
public class ForLoop {
    public static void main(String[] args) {
        // Basic for loop
        System.out.println("Numbers from 1 to 5:");
        for(int i = 1; i <= 5; i++) {
            System.out.println("Iteration: " + i);
        }
        
        // Loop with different increment
        System.out.println("\\nEven numbers from 0 to 10:");
        for(int i = 0; i <= 10; i += 2) {
            System.out.print(i + " ");
        }
        System.out.println();
        
        // Nested for loop
        System.out.println("\\nMultiplication table (1-3):");
        for(int i = 1; i <= 3; i++) {
            for(int j = 1; j <= 3; j++) {
                System.out.println(i + " x " + j + " = " + (i * j));
            }
            System.out.println();
        }
    }
}`
  },
  {
    title: "While and Do-While Loops",
    code: `// While and Do-While Loops
import java.util.Scanner;

public class WhileLoops {
    public static void main(String[] args) {
        // While loop
        int count = 1;
        System.out.println("Counting to 5 with while loop:");
        while(count <= 5) {
            System.out.print(count + " ");
            count++;
        }
        System.out.println();
        
        // Do-while loop
        Scanner scanner = new Scanner(System.in);
        int number;
        System.out.println("\\nDo-while example (enter 0 to stop):");
        do {
            System.out.print("Enter a number: ");
            number = scanner.nextInt();
            System.out.println("You entered: " + number);
        } while(number != 0);
        
        // Break and continue
        System.out.println("\\nBreak and continue example:");
        int i = 0;
        while(i < 10) {
            i++;
            if(i == 3) {
                continue; // Skip 3
            }
            if(i == 8) {
                break;    // Stop at 8
            }
            System.out.print(i + " ");
        }
        System.out.println();
        
        scanner.close();
    }
}`
  },
  {
    title: "Arrays",
    code: `// Arrays
public class ArraysExample {
    public static void main(String[] args) {
        // One-dimensional array
        int[] numbers = {1, 2, 3, 4, 5};
        
        System.out.println("Array elements:");
        for(int i = 0; i < numbers.length; i++) {
            System.out.println("numbers[" + i + "] = " + numbers[i]);
        }
        
        // Enhanced for loop
        System.out.println("\\nUsing enhanced for loop:");
        for(int num : numbers) {
            System.out.print(num + " ");
        }
        System.out.println();
        
        // Multi-dimensional array
        int[][] matrix = {
            {1, 2, 3},
            {4, 5, 6},
            {7, 8, 9}
        };
        
        System.out.println("\\n2D Array:");
        for(int i = 0; i < matrix.length; i++) {
            for(int j = 0; j < matrix[i].length; j++) {
                System.out.print(matrix[i][j] + " ");
            }
            System.out.println();
        }
    }
}`
  },
  {
    title: "String Operations",
    code: `// String Operations
public class StringOperations {
    public static void main(String[] args) {
        String str1 = "Hello";
        String str2 = "World";
        
        // String concatenation
        String result = str1 + " " + str2;
        System.out.println("Concatenation: " + result);
        
        // String methods
        System.out.println("Length: " + result.length());
        System.out.println("Uppercase: " + result.toUpperCase());
        System.out.println("Lowercase: " + result.toLowerCase());
        System.out.println("Substring: " + result.substring(0, 5));
        System.out.println("Contains 'World': " + result.contains("World"));
        System.out.println("Index of 'W': " + result.indexOf('W'));
        
        // String comparison
        String name1 = "Rajan";
        String name2 = "rajan";
        System.out.println("Equals: " + name1.equals(name2));
        System.out.println("Equals ignore case: " + name1.equalsIgnoreCase(name2));
        
        // String formatting
        String formatted = String.format("Name: %s, Age: %d, Salary: %.2f", "Rajan", 25, 50000.50);
        System.out.println("Formatted: " + formatted);
    }
}`
  },
  {
    title: "Methods",
    code: `// Methods
public class Methods {
    public static void main(String[] args) {
        // Basic method call
        int result = add(5, 3);
        System.out.println("5 + 3 = " + result);
        
        // Method with different return type
        double area = calculateArea(5.0);
        System.out.println("Area of circle: " + area);
        
        // Void method
        greet("Rajan");
        
        // Method overloading
        System.out.println("Add integers: " + add(10, 20));
        System.out.println("Add doubles: " + add(10.5, 20.3));
        System.out.println("Add three numbers: " + add(10, 20, 30));
    }
    
    // Method to add two integers
    public static int add(int a, int b) {
        return a + b;
    }
    
    // Overloaded method to add two doubles
    public static double add(double a, double b) {
        return a + b;
    }
    
    // Overloaded method to add three integers
    public static int add(int a, int b, int c) {
        return a + b + c;
    }
    
    // Method to calculate area of circle
    public static double calculateArea(double radius) {
        return Math.PI * radius * radius;
    }
    
    // Void method
    public static void greet(String name) {
        System.out.println("Hello, " + name + "!");
    }
}`
  },
  {
    title: "Classes and Objects",
    code: `// Classes and Objects
class Student {
    // Instance variables
    private String name;
    private int age;
    private double gpa;
    
    // Constructor
    public Student(String name, int age, double gpa) {
        this.name = name;
        this.age = age;
        this.gpa = gpa;
    }
    
    // Getter methods
    public String getName() {
        return name;
    }
    
    public int getAge() {
        return age;
    }
    
    public double getGpa() {
        return gpa;
    }
    
    // Setter methods
    public void setName(String name) {
        this.name = name;
    }
    
    public void setAge(int age) {
        this.age = age;
    }
    
    public void setGpa(double gpa) {
        this.gpa = gpa;
    }
    
    // Method to display student info
    public void displayInfo() {
        System.out.println("Name: " + name);
        System.out.println("Age: " + age);
        System.out.println("GPA: " + gpa);
    }
    
    // Method to check if student is eligible for scholarship
    public boolean isEligibleForScholarship() {
        return gpa >= 3.5;
    }
}

public class OOPExample {
    public static void main(String[] args) {
        // Creating objects
        Student student1 = new Student("Rajan", 20, 3.8);
        Student student2 = new Student("Amit", 22, 3.2);
        
        // Using object methods
        System.out.println("Student 1:");
        student1.displayInfo();
        System.out.println("Eligible for scholarship: " + student1.isEligibleForScholarship());
        
        System.out.println("\\nStudent 2:");
        student2.displayInfo();
        System.out.println("Eligible for scholarship: " + student2.isEligibleForScholarship());
        
        // Using getter and setter
        student1.setGpa(3.9);
        System.out.println("\\nUpdated GPA: " + student1.getGpa());
    }
}`
  },
  {
    title: "Inheritance",
    code: `// Inheritance
// Parent class
class Animal {
    protected String name;
    protected int age;
    
    public Animal(String name, int age) {
        this.name = name;
        this.age = age;
    }
    
    public void eat() {
        System.out.println(name + " is eating.");
    }
    
    public void sleep() {
        System.out.println(name + " is sleeping.");
    }
    
    public void makeSound() {
        System.out.println(name + " makes a sound.");
    }
}

// Child class
class Dog extends Animal {
    private String breed;
    
    public Dog(String name, int age, String breed) {
        super(name, age); // Call parent constructor
        this.breed = breed;
    }
    
    // Method overriding
    @Override
    public void makeSound() {
        System.out.println(name + " barks: Woof! Woof!");
    }
    
    // New method specific to Dog
    public void fetch() {
        System.out.println(name + " is fetching the ball.");
    }
    
    public void displayInfo() {
        System.out.println("Dog: " + name + ", Age: " + age + ", Breed: " + breed);
    }
}

// Another child class
class Cat extends Animal {
    private String color;
    
    public Cat(String name, int age, String color) {
        super(name, age);
        this.color = color;
    }
    
    // Method overriding
    @Override
    public void makeSound() {
        System.out.println(name + " meows: Meow! Meow!");
    }
    
    // New method specific to Cat
    public void climb() {
        System.out.println(name + " is climbing the tree.");
    }
    
    public void displayInfo() {
        System.out.println("Cat: " + name + ", Age: " + age + ", Color: " + color);
    }
}

public class InheritanceExample {
    public static void main(String[] args) {
        Dog dog = new Dog("Buddy", 3, "Golden Retriever");
        Cat cat = new Cat("Whiskers", 2, "White");
        
        dog.displayInfo();
        dog.eat();
        dog.makeSound();
        dog.fetch();
        
        System.out.println();
        
        cat.displayInfo();
        cat.sleep();
        cat.makeSound();
        cat.climb();
    }
}`
  },
  {
    title: "Polymorphism",
    code: `// Polymorphism
abstract class Shape {
    protected String color;
    
    public Shape(String color) {
        this.color = color;
    }
    
    // Abstract method
    public abstract double calculateArea();
    
    // Concrete method
    public void displayColor() {
        System.out.println("Color: " + color);
    }
}

class Circle extends Shape {
    private double radius;
    
    public Circle(String color, double radius) {
        super(color);
        this.radius = radius;
    }
    
    @Override
    public double calculateArea() {
        return Math.PI * radius * radius;
    }
    
    public void displayInfo() {
        System.out.println("Circle - Radius: " + radius);
        displayColor();
        System.out.println("Area: " + calculateArea());
    }
}

class Rectangle extends Shape {
    private double length;
    private double width;
    
    public Rectangle(String color, double length, double width) {
        super(color);
        this.length = length;
        this.width = width;
    }
    
    @Override
    public double calculateArea() {
        return length * width;
    }
    
    public void displayInfo() {
        System.out.println("Rectangle - Length: " + length + ", Width: " + width);
        displayColor();
        System.out.println("Area: " + calculateArea());
    }
}

public class PolymorphismExample {
    public static void main(String[] args) {
        // Polymorphism - same type, different forms
        Shape shape1 = new Circle("Red", 5.0);
        Shape shape2 = new Rectangle("Blue", 4.0, 6.0);
        
        // Using polymorphism
        Shape[] shapes = {shape1, shape2};
        
        for(Shape shape : shapes) {
            System.out.println("Area: " + shape.calculateArea());
            shape.displayColor();
            System.out.println();
        }
        
        // Downcasting to access specific methods
        if(shape1 instanceof Circle) {
            Circle circle = (Circle) shape1;
            circle.displayInfo();
        }
        
        System.out.println();
        
        if(shape2 instanceof Rectangle) {
            Rectangle rectangle = (Rectangle) shape2;
            rectangle.displayInfo();
        }
    }
}`
  },
  {
    title: "Interfaces",
    code: `// Interfaces
interface Vehicle {
    void start();
    void stop();
    void accelerate(int speed);
    void brake();
}

interface Electric {
    void charge();
    int getBatteryLevel();
}

// Class implementing multiple interfaces
class ElectricCar implements Vehicle, Electric {
    private String model;
    private int currentSpeed;
    private int batteryLevel;
    
    public ElectricCar(String model) {
        this.model = model;
        this.currentSpeed = 0;
        this.batteryLevel = 100;
    }
    
    @Override
    public void start() {
        System.out.println(model + " is starting silently.");
    }
    
    @Override
    public void stop() {
        currentSpeed = 0;
        System.out.println(model + " has stopped.");
    }
    
    @Override
    public void accelerate(int speed) {
        currentSpeed += speed;
        batteryLevel -= 5;
        System.out.println(model + " accelerating to " + currentSpeed + " km/h");
    }
    
    @Override
    public void brake() {
        currentSpeed = Math.max(0, currentSpeed - 20);
        System.out.println(model + " braking. Current speed: " + currentSpeed + " km/h");
    }
    
    @Override
    public void charge() {
        batteryLevel = 100;
        System.out.println(model + " is fully charged.");
    }
    
    @Override
    public int getBatteryLevel() {
        return batteryLevel;
    }
    
    public void displayStatus() {
        System.out.println("Model: " + model);
        System.out.println("Current Speed: " + currentSpeed + " km/h");
        System.out.println("Battery Level: " + batteryLevel + "%");
    }
}

public class InterfaceExample {
    public static void main(String[] args) {
        ElectricCar tesla = new ElectricCar("Tesla Model S");
        
        tesla.displayStatus();
        System.out.println();
        
        tesla.start();
        tesla.accelerate(50);
        tesla.accelerate(30);
        tesla.brake();
        System.out.println("Battery Level: " + tesla.getBatteryLevel() + "%");
        System.out.println();
        
        tesla.charge();
        tesla.stop();
        System.out.println();
        
        tesla.displayStatus();
    }
}`
  },
  {
    title: "Exception Handling",
    code: `// Exception Handling
import java.util.Scanner;
import java.util.InputMismatchException;

public class ExceptionHandling {
    public static void main(String[] args) {
        Scanner scanner = new Scanner(System.in);
        
        // Basic try-catch
        try {
            System.out.print("Enter a number: ");
            int number = scanner.nextInt();
            int result = 10 / number;
            System.out.println("10 / " + number + " = " + result);
        } catch (ArithmeticException e) {
            System.out.println("Error: Cannot divide by zero!");
        } catch (InputMismatchException e) {
            System.out.println("Error: Please enter a valid integer!");
        } finally {
            System.out.println("This block always executes.");
        }
        
        // Multiple exceptions in one catch (Java 7+)
        try {
            int[] numbers = {1, 2, 3};
            System.out.print("Enter index to access: ");
            int index = scanner.nextInt();
            System.out.println("Value at index " + index + ": " + numbers[index]);
        } catch (ArrayIndexOutOfBoundsException | InputMismatchException e) {
            System.out.println("Error: Invalid input or index out of bounds!");
        }
        
        // Custom exception
        try {
            System.out.print("\\nEnter your age: ");
            int age = scanner.nextInt();
            validateAge(age);
            System.out.println("Age is valid!");
        } catch (InvalidAgeException e) {
            System.out.println("Error: " + e.getMessage());
        }
        
        scanner.close();
    }
    
    // Method that throws custom exception
    public static void validateAge(int age) throws InvalidAgeException {
        if (age < 0) {
            throw new InvalidAgeException("Age cannot be negative!");
        } else if (age > 150) {
            throw new InvalidAgeException("Age cannot be greater than 150!");
        }
    }
}

// Custom exception class
class InvalidAgeException extends Exception {
    public InvalidAgeException(String message) {
        super(message);
    }
}`
  },
  {
    title: "Collections Framework",
    code: `// Collections Framework
import java.util.ArrayList;
import java.util.HashMap;
import java.util.HashSet;
import java.util.LinkedList;
import java.util.TreeSet;

public class CollectionsExample {
    public static void main(String[] args) {
        // ArrayList
        System.out.println("=== ArrayList ===");
        ArrayList<String> arrayList = new ArrayList<>();
        arrayList.add("Apple");
        arrayList.add("Banana");
        arrayList.add("Cherry");
        arrayList.add("Apple"); // Duplicates allowed
        
        System.out.println("ArrayList: " + arrayList);
        System.out.println("Size: " + arrayList.size());
        System.out.println("Contains 'Banana': " + arrayList.contains("Banana"));
        
        // LinkedList
        System.out.println("\\n=== LinkedList ===");
        LinkedList<Integer> linkedList = new LinkedList<>();
        linkedList.add(10);
        linkedList.add(20);
        linkedList.addFirst(5);
        linkedList.addLast(30);
        
        System.out.println("LinkedList: " + linkedList);
        System.out.println("First: " + linkedList.getFirst());
        System.out.println("Last: " + linkedList.getLast());
        
        // HashSet
        System.out.println("\\n=== HashSet ===");
        HashSet<String> hashSet = new HashSet<>();
        hashSet.add("Apple");
        hashSet.add("Banana");
        hashSet.add("Cherry");
        hashSet.add("Apple"); // Duplicates not allowed
        
        System.out.println("HashSet: " + hashSet);
        System.out.println("Size: " + hashSet.size());
        
        // TreeSet
        System.out.println("\\n=== TreeSet ===");
        TreeSet<Integer> treeSet = new TreeSet<>();
        treeSet.add(50);
        treeSet.add(20);
        treeSet.add(80);
        treeSet.add(10);
        
        System.out.println("TreeSet (sorted): " + treeSet);
        System.out.println("First: " + treeSet.first());
        System.out.println("Last: " + treeSet.last());
        
        // HashMap
        System.out.println("\\n=== HashMap ===");
        HashMap<String, Integer> hashMap = new HashMap<>();
        hashMap.put("Rajan", 25);
        hashMap.put("Amit", 30);
        hashMap.put("Priya", 22);
        
        System.out.println("HashMap: " + hashMap);
        System.out.println("Rajan's age: " + hashMap.get("Rajan"));
        System.out.println("Contains key 'Amit': " + hashMap.containsKey("Amit"));
        
        // Iterating through collections
        System.out.println("\\n=== Iterating ===");
        System.out.println("ArrayList elements:");
        for(String fruit : arrayList) {
            System.out.println("- " + fruit);
        }
        
        System.out.println("\\nHashMap entries:");
        for(HashMap.Entry<String, Integer> entry : hashMap.entrySet()) {
            System.out.println(entry.getKey() + ": " + entry.getValue());
        }
    }
}`
  },
  {
    title: "File Handling",
    code: `// File Handling
import java.io.*;
import java.util.Scanner;

public class FileHandling {
    public static void main(String[] args) {
        // Writing to a file
        try {
            FileWriter writer = new FileWriter("example.txt");
            writer.write("Hello, this is a file handling example.\\n");
            writer.write("This is line 2 of the file.\\n");
            writer.write("This is line 3.\\n");
            writer.close();
            System.out.println("Data written to file successfully!");
        } catch (IOException e) {
            System.out.println("Error writing to file: " + e.getMessage());
        }
        
        // Reading from a file using Scanner
        System.out.println("\\nReading from file using Scanner:");
        try {
            File file = new File("example.txt");
            Scanner scanner = new Scanner(file);
            
            while(scanner.hasNextLine()) {
                String line = scanner.nextLine();
                System.out.println(line);
            }
            scanner.close();
        } catch (FileNotFoundException e) {
            System.out.println("File not found: " + e.getMessage());
        }
        
        // Reading from a file using BufferedReader
        System.out.println("\\nReading from file using BufferedReader:");
        try {
            BufferedReader reader = new BufferedReader(new FileReader("example.txt"));
            String line;
            
            while((line = reader.readLine()) != null) {
                System.out.println(line);
            }
            reader.close();
        } catch (IOException e) {
            System.out.println("Error reading file: " + e.getMessage());
        }
        
        // Appending to a file
        try {
            FileWriter writer = new FileWriter("example.txt", true);
            writer.write("This line was appended.\\n");
            writer.close();
            System.out.println("\\nData appended to file successfully!");
        } catch (IOException e) {
            System.out.println("Error appending to file: " + e.getMessage());
        }
    }
}`
  },
  {
    title: "Multithreading",
    code: `// Multithreading
class MyThread extends Thread {
    private String threadName;
    
    public MyThread(String name) {
        this.threadName = name;
    }
    
    @Override
    public void run() {
        for(int i = 1; i <= 5; i++) {
            System.out.println(threadName + " - Count: " + i);
            try {
                Thread.sleep(1000); // Sleep for 1 second
            } catch (InterruptedException e) {
                System.out.println(threadName + " interrupted.");
            }
        }
        System.out.println(threadName + " finished.");
    }
}

class MyRunnable implements Runnable {
    private String taskName;
    
    public MyRunnable(String name) {
        this.taskName = name;
    }
    
    @Override
    public void run() {
        for(int i = 1; i <= 3; i++) {
            System.out.println(taskName + " - Task: " + i);
            try {
                Thread.sleep(500); // Sleep for 0.5 seconds
            } catch (InterruptedException e) {
                System.out.println(taskName + " interrupted.");
            }
        }
        System.out.println(taskName + " completed.");
    }
}

public class MultithreadingExample {
    public static void main(String[] args) {
        // Using Thread class
        System.out.println("=== Using Thread Class ===");
        MyThread thread1 = new MyThread("Thread-1");
        MyThread thread2 = new MyThread("Thread-2");
        
        thread1.start();
        thread2.start();
        
        // Wait for threads to complete
        try {
            thread1.join();
            thread2.join();
        } catch (InterruptedException e) {
            System.out.println("Main thread interrupted.");
        }
        
        // Using Runnable interface
        System.out.println("\\n=== Using Runnable Interface ===");
        Thread runnableThread1 = new Thread(new MyRunnable("Task-1"));
        Thread runnableThread2 = new Thread(new MyRunnable("Task-2"));
        Thread runnableThread3 = new Thread(new MyRunnable("Task-3"));
        
        runnableThread1.start();
        runnableThread2.start();
        runnableThread3.start();
        
        // Wait for all threads to complete
        try {
            runnableThread1.join();
            runnableThread2.join();
            runnableThread3.join();
        } catch (InterruptedException e) {
            System.out.println("Main thread interrupted.");
        }
        
        System.out.println("\\nAll threads completed. Main thread finishing.");
    }
}`
  }
];

export default javaLessons;